import React, { Component } from 'react';
import { FormGroup, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import PropTypes from 'prop-types';
import { InputErrorType } from 'types/CommonTypes';
import withRequired from './withRequired';

class InputEmail extends Component {
    render() {
        let errorMgs;

        if (this.props.errors) {
            this.props.errors.details.forEach(error => {
                if (error.fieldName === this.props.name) {
                    errorMgs = error.messages;
                }
            });
        }

        return (
            <FormGroup>
                {this.props.label ? (
                    <Label for={this.props.name}>
                        {this.props.required ? <sup>*</sup> : ''}{' '}
                        {this.props.label}
                    </Label>
                ) : (
                    ''
                )}
                <InputGroup
                    className={
                        errorMgs ? 'form-control is-invalid' : 'form-control'
                    }
                >
                    <Input
                        type="email"
                        name={this.props.name}
                        autoComplete={this.props.autoComplete}
                        value={this.props.value || ''}
                        onChange={this.props.handleChange}
                        required={this.props.required}
                        placeholder={this.props.placeholder}
                    />
                </InputGroup>
                <FormFeedback>
                    {errorMgs
                        ? errorMgs.map((message, k) => (
                              <li key={k}>{message}</li>
                          ))
                        : ''}
                </FormFeedback>
            </FormGroup>
        );
    }
}

InputEmail.propTypes = {
    errors: InputErrorType,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    autoComplete: PropTypes.string,
    required: PropTypes.bool,
    handleChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
};

InputEmail.defaultProps = {
    errors: undefined,
    label: null,
    autoComplete: null,
    required: false,
    placeholder: null,
    value: undefined,
};

export default withRequired(InputEmail);
